export enum SVTEnum {
    'CV' = 'CV',
    'BV' = 'BV', // Am equal to CV
    'CCV' = 'CCV',
    'HTCCV' = 'HTCCV', // Am equal to CCV
    'QCV' = 'QCV',
    'ZV' = 'ZV', // Am equal to QCV
    'BFV' = 'BFV',
    'GV' = 'GV',
    'FCU' = 'FCU', // Ap uniq?
    'PICCV' = 'PICCV',
    'PIQCV' = 'PIQCV',
    'EPIV' = 'EPIV',
    'EV' = 'EV',
    'PIFLV' = 'PIFLV',
    '6-way CCV' = '6-way CCV',
    '6-way EPIV' = '6-way EPIV',
    '6-way PIQCV' = '6-way PIQCV',
    '6-way QCV' = '6-way QCV',
}
